import { useCallback, useEffect, useState } from "react";
import MediaTable from "./MediaTable";
import { Link } from "react-router-dom";
import "./media.css";
import { ApiEndpoints } from "../../helper/ApiEndpoints";
import ApiRequest from "../../helper/ApiRequest";

const MediaEditPath = "edit-media";
const mediaListEndpoint = ApiEndpoints.adminMedia.adminMediaList;
const mediaDeleteEndpoint = ApiEndpoints.adminMedia.adminMediaDelete;
const tableHeader = ["Title", "URL"];
const tbody = ["title", "link"];

export default function AdminMedia() {
  const [data, setData] = useState([]);

  const dataFetch = useCallback(
    async () => {
      try {
        const response = await ApiRequest("GET", mediaListEndpoint);
        const result = response.medias;
        setData(result);

      } catch (error) {
        console.log(error);
      }
    }, [mediaListEndpoint]);

  useEffect(() => {
    dataFetch();
  }, [useEffect])

  const handleDelete = async (media_id) => {
    const payload = { media_id };
    try {
      await ApiRequest("POST", mediaDeleteEndpoint, payload);
      dataFetch();
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <div className="header-add-category">
        <h5>Media</h5>
      </div>
      <div className="add-media-section">
        <Link className="default-btn" to="/admin/add-media">
          Add Media
        </Link>
        <MediaTable
          data={data}
          tableHeader={tableHeader}
          tbody={tbody}
          editPath={MediaEditPath}
          onDelete={handleDelete}
        />
      </div>
    </>
  )
}
